import { SettlementTiming } from '@ordering/gql/graphql';
import { CollectionPoint } from '@ordering/types/Order';

export enum Mode {
  PayNow = 'payNow',
  OpenOrder = 'openOrder',
}

export type SettlementMode = { type: Mode.PayNow } | { type: Mode.OpenOrder; collectionPoint: CollectionPoint };

export const getSettlementMode = (
  settlement: SettlementTiming | undefined,
  collectionPoint: CollectionPoint | null | undefined
): SettlementMode => {
  if (settlement === SettlementTiming.After && collectionPoint?.id) {
    return { type: Mode.OpenOrder, collectionPoint };
  }
  return { type: Mode.PayNow };
};
